import styled from "@emotion/styled";
import { Divider, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(p) => alpha(p.theme.colors.white, 0.12)};
  justify-content: space-between;
  border-radius: 1rem;
  padding: 1rem;
  max-width: 440px;

  ${(p) => p.theme.media.mobileDown} {
    grid-template-columns: 1fr;
  }
`;

export const ProductInfo = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
`;

export const ProductNameContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  justify-content: space-between;
  gap: 0.5rem;
  align-items: center;
  ${(p) => p.theme.media.laptopDown} {
    grid-template-columns: 1fr;
    row-gap: 1rem;
  }

  p {
    font-family: ${(p) => p.theme.title.fonts.primary};
    font-size: ${(p) => p.theme.title.fontSizes.h5};
    font-weight: 600;
    color: ${(p) => p.theme.text.colors.primary};
    line-height: 100%;
  }
`;

export const ProductDescription = styled(Typography)`
  color: ${(p) => p.theme.text.colors.secondary};
  font-size: ${(p) => p.theme.text.fontSizes.l};
  line-height: 120%;
  max-width: calc(100% - 7rem);

  ${(p) => p.theme.media.laptopDown} {
    max-width: 100%;
  }
`;

export const TotalInfo = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
`;

export const TotalItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    line-height: 100%;
    font-size: ${(p) => p.theme.text.fontSizes.m};
    color: ${(p) => p.theme.colors.white};
  }
`;

export const Price = styled(Typography)`
  color: ${(p) => p.theme.colors.white};
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: ${(p) => p.theme.text.fonts.primary};
  font-size: ${(p) => p.theme.text.fontSizes.m}!important;
  font-weight: 700;
`;

// export const DiscountPercentage = styled.span`
//   color: ${(p) => p.theme.colors.error};
//   display: flex;
//   align-items: center;
//   gap: 0.5rem;
//   font-size: ${(p) => p.theme.text.fontSizes.l};
//   font-family: ${(p) => p.theme.text.fonts.primary};
//   font-weight: 100;

//   ${(p) => p.theme.media.mobileDown} {
//     font-size: ${(p) => p.theme.text.fontSizes.l};
//   }
// `;

// export const DiscountWas = styled.span`
//   color: ${(p) => p.theme.text.colors.secondary};
//   font-size: ${(p) => p.theme.text.fontSizes.m};
//   /* text-decoration: line-through; */
// `;

// export const SpecialOfferTag = styled.span`
//   color: ${(p) => p.theme.colors.background};
//   font-size: 0.8rem;
//   background-color: ${(p) => p.theme.colors.error};
//   font-family: ${(p) => p.theme.title.fonts.primary};
//   padding: 0.25rem 1rem;
//   border-radius: 0.5rem;
// `;

export const OfferInfo = styled(Typography)`
  display: flex;
  gap: 0.25rem;
  align-items: center;
  position: relative;
  border-radius: 1rem;
  cursor: help;

  span {
    display: flex;
    align-items: center;
    font-size: ${(p) => p.theme.text.fontSizes.xl};
    color: ${(p) => p.theme.colors.primary};
    background-color: #ffdf83;
    padding: 0.25rem 0.75rem;
    border-radius: 0.375rem;
    font-weight: 500;
  }

  ${(p) => p.theme.media.mobileDown} {
    align-items: flex-start;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
`;

export const CollectPaymentDetailsContainer = styled.div`
  width: 100%;
  max-width: 85%;
`;

export const StyledDivider = styled(Divider)`
  border-color: ${(p) => alpha(p.theme.colors.white, 0.15)};
  margin: 0.5rem 0;
`;
